document.addEventListener('click', function (event) {
  var card = event.target.closest('[data-big-card]');
  if (!card) return;
  if (card.closest('.new-landing-big-cards__group--static')) return;
  if (event.target.closest('[data-big-card-reveal]') && !event.target.closest('[data-big-card-toggle]')) return;

  var reveal = card.querySelector('[data-big-card-reveal]');
  if (!reveal) return;

  var isOpen = card.classList.contains('is-open');

  if (isOpen) {
    reveal.style.maxHeight = '0px';
    card.classList.remove('is-open');
  } else {
    card.classList.add('is-open');
    reveal.style.maxHeight = reveal.scrollHeight + 'px';
  }
});

window.addEventListener('resize', function () {
  document.querySelectorAll('[data-big-card].is-open [data-big-card-reveal]').forEach(function (reveal) {
    reveal.style.maxHeight = reveal.scrollHeight + 'px';
  });
});
